import {
  InstaLogo,
  facebookLogo,
  SocialLogo,
  YoutubeLogo,
  TwitterLogo,
  LinkedinLogo
} from "@/assets";
import { time } from "console";
import { title } from "process";

export const ourPresence = [{ title: "India" }, { title: "Vietnam" }, {title: "Singapore"}];
export const legal = [
  { title: "Privacy Policy" },
  { title: "Terms & Conditions" },
];

export const socials = [
  {
    href: "https://www.facebook.com/share/1AXSfjB69v/?mibextid=wwXIfr",
    icon: facebookLogo,
    alt: "Facebook",
  },
  {
    href: "https://www.linkedin.com/company/intron-life-sciences-private-limited/",
    icon: LinkedinLogo,
    alt: "LinkedIn",
  },
  {
    href: "https://www.youtube.com/@IntronLifeSciencesIndia",
    icon: YoutubeLogo,
    alt: "YouTube",
  },
  {
    href: "https://www.instagram.com/intronlifesciences22?igsh=amRjcXg5bXlleXI5",
    icon: InstaLogo,
    alt: "Instagram",
  }, 
  {
    href: "https://x.com/intronl?s=21", // 🔹 replace with correct Twitter link
    icon: TwitterLogo,
    alt: "Twitter",
  }, 
  {
    href: "https://www.threads.com/@intronlifesciences22?igshid=NTc4MTIwNjQ2YQ==", // 🔹 replace with correct link for Social
    icon: SocialLogo,
    alt: "Social",
  },
];

